module.exports = __webpack_public_path__ + "1dd47052718c25923a37615ba1ebe65f.png";